import "./style.css";
import {EXTERNAL_NAME} from "@meltwater/mi-manifest-client/build/external-name.js";

const sharableDashboardManagerConfig = {
  name: "mwPrInsightSharableDashboardReportManager",
  bindings: {
    companyId: "<?",
    items: "<?",
    shareLimitReached: "<?",
  },
  template: `
        <div ng-cloak layout="column" ng-if="$ctrl.items.length > 0"> 
            <md-content id="mw-sharabable-dashboards-table__content" class="mw-flex-padding" flex style="padding: 2px;">
                <mw-table>
                    <header class="mw-table__header" ng-class="[{'mw-table__header--selected-items': $ctrl.selectedItems.length}]">
                        <mw-collection-header ng-if="!$ctrl.selectedItems.length" is-search-active="$ctrl.isSearchActive" is-header-title-visible="$ctrl.isHeaderTitleVisible()" on-search="$ctrl.search($event)" search-input-placeholder="{{'Find Dashboards' | translate}}" on-search-toggle="$ctrl.onSearchToggle($event)" collection-type='table' on-change-collection-view="$ctrl.toggleCardsView($event)">
                            <mw-collection-header-title>
                                <span class="mw-collection-header__title" ng-if="$ctrl.isHeaderTitleVisible()" translate>Dashboards</span>
                            </mw-collection-header-title>
                        </mw-collection-header>
                        
                        <mw-collection-bulk-action ng-if="$ctrl.selectedItems.length" selected-items-count="$ctrl.selectedItems.length" on-reset-selected-items="$ctrl.resetSelectedItems()">
                            <md-button ng-click="$ctrl.confirmBulkDelete($event)" class="md-icon-button" aria-label="{'Delete Selected Items' | translate}" >
                                <md-tooltip md-delay="500"><span translate>Delete Selected Items</span></md-tooltip>
                                <md-icon md-svg-icon="content:ic_delete_sweep_24px" translate>delete</md-icon>
                            </md-button>
                        </mw-collection-bulk-action>
                    </header>
                    
                    <md-card ng-show="$ctrl.searchText && $ctrl.filteredItems.length === 0">
                        <md-card-content class="mw-empty-state-container">
                            <mw-empty-state>
                                <span class="mw-empty-state__text">{{'No results for' | translate}} <span class="mw-empty-state__search-text">"{{$ctrl.searchText}}"</span></span>
                            </mw-empty-state>
                        </md-card-content>
                    </md-card>
                    
                    <md-card ng-hide="$ctrl.searchText && $ctrl.filteredItems.length === 0">
                        <md-table-container>
                            <table class="mw-table--actions-visible" md-table md-progress="$ctrl.loadPagePromise" md-row-select="true" multiple="true" ng-model="$ctrl.selectedItems" md-whiteframe="1">
                                <thead md-head md-order="$ctrl.orderBy" md-on-reorder="$ctrl.onReorder">
                                    <tr md-row>
                                        <th class="mw-table__text-column" md-column md-order-by="displayName"><span translate>Title</span></th>
                                        <th class="mw-table__date-column" md-column md-order-by="created" hide-xs><span translate>Created</span></th>
                                        <th class="mw-table__date-column" md-column md-order-by="modified"><span translate>Last updated</span></th>
                                        <th class="mw-table__actions-column" md-column><span></span></th>
                                    </tr>
                                </thead>
                                <tbody md-body>
                                    <tr md-row ng-repeat="item in $ctrl.filteredItems = ($ctrl.items | filter:$ctrl.searchText) | orderBy: $ctrl.orderBy | limitTo: $ctrl.paging.itemsPerPage: ($ctrl.paging.selectedPage - 1) * $ctrl.paging.itemsPerPage" md-select="item" md-select-id="_id" md-auto-select="false" ng-click="$ctrl.view(item)">
                                        <td class="mw-table__text-column mw-table__greedy-column" md-cell>
                                            <span>{{::item.displayName}}</span>
                                        </td>
                                        <td class="mw-table__date-column" md-cell hide-xs>{{::item.formattedCreated}}</td>
                                        <td class="mw-table__date-column" md-cell>{{::item.formattedModified}}</td>
                                        <td class="mw-table__actions-column" md-cell>
                                            <md-menu md-position-mode="target-right target" md-offset="0 50" class="mw-menu">
                                                <mw-menu-trigger-icon-button icon="navigation:ic_more_vert_24px" tooltip="{{'Open Menu' | translate}}" on-click="$mdMenu.open($event)"></mw-menu-trigger-icon-button>
                                                <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                                    <mw-menu-item label="{{'View' | translate}}" icon="ic_open_in_new_24px" aria-label="{{'View' | translate}}" on-click="$ctrl.view(item)"><span translate>View</span></mw-menu-item>
                                                    <mw-menu-item label="{{'Password and link' | translate}}" icon="communication:ic_vpn_key_24px" aria-label="{{'Password and link' | translate}}" on-click="$ctrl.showPassword(item, $event)"><span translate>Password and link</span></mw-menu-item>
                                                    <mw-menu-item label="{{'Edit' | translate}}" icon="meltwater:edit" aria-label="{{'Edit' | translate}}" on-click="$ctrl.edit(item)"><span translate>Edit</span></mw-menu-item>
                                                    <mw-menu-item ng-if="$ctrl.mwEnvDetector.browser.indexOf('chrome') >= 0" label="{{'Print' | translate}}" icon="action:ic_print_24px" aria-label="{{'Print' | translate}}" on-click="$ctrl.print(item)"><span translate>Print</span></mw-menu-item>
                                                    <mw-menu-item label="{{'Delete' | translate}}" icon="ic_delete_24px" aria-label="{{'Delete' | translate}}" on-click="$ctrl.confirmDelete(item, $event)"><span translate>Delete</span></mw-menu-item>
                                                </md-menu-content>
                                            </md-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </md-table-container>
                        <mw-table-pagination scroll-container-id="mw-sharabable-dashboards-table__content" items-per-page="$ctrl.paging.itemsPerPage" page="$ctrl.paging.selectedPage" item-total="$ctrl.filteredItems.length" on-page-change="$ctrl.onPage($event.page, $event.limit)"></mw-table-pagination>
                    </md-card>
                </mw-table>
            </md-content>
        </div>
        <div layout="column" layout-align="top-center" ng-if="$ctrl.items.length === 0">
            <mw-empty-state icon="communication:ic_no_sim_24px" icon-size="medium">
                <mw-empty-state-text translate> No results </mw-empty-state-text>
                <mw-empty-state-sub-text translate></mw-empty-state-sub-text>
            </mw-empty-state>
        </div>
        
    `,
};

class SharableDashboardManagerComponent {
  constructor(
    $rootScope,
    $window,
    $timeout,
    $mdMedia,
    $mdToast,
    $mdDialog,
    $http,
    $location,
    $sce,
    stateService,
    mwEnvDetector,
    CoreUserService,
    FAIRHAIR_WEB_URL,
    SHARABLE_DASHBOARD_URL,
    NEW_SHARABLE_DASHBOARD_URL,
    SHARABLE_DASHBOARDS_LIMIT,
    SHARABLE_DASHBOARDS_PREMIUM_LIMIT,
    $translate
  ) {
    $rootScope.$broadcast("app-container__update-title", "Dashboards");
    $location.hash("");
    $mdDialog.hide(); // In case we're coming here from a flexi modal, make sure it's closed

    this.$window = $window;
    this.$timeout = $timeout;
    this.$mdMedia = $mdMedia;
    this.$mdToast = $mdToast;
    this.$mdDialog = $mdDialog;
    this.$http = $http;
    this.$location = $location;
    this.$sce = $sce;
    this.stateService = stateService;
    this.mwEnvDetector = mwEnvDetector;
    this.FAIRHAIR_WEB_URL = FAIRHAIR_WEB_URL;
    this.SHARABLE_DASHBOARD_URL = SHARABLE_DASHBOARD_URL;
    this.NEW_SHARABLE_DASHBOARD_URL = NEW_SHARABLE_DASHBOARD_URL;
    this.SHARABLE_DASHBOARDS_LIMIT = SHARABLE_DASHBOARDS_LIMIT;
    this.SHARABLE_DASHBOARDS_PREMIUM_LIMIT = SHARABLE_DASHBOARDS_PREMIUM_LIMIT;
    this.$translate = $translate;

    this.loadPagePromise = null;
    this.isSearchActive = false;

    this.selectedItems = [];
    this.filteredItems = [];

    this.orderBy = "-modified";
    this.sortOrder = "DESC";
    this.searchText = "";
    this.paging = {
      itemsPerPage: 30,
      selectedPage: 1,
      totalItems: 0,
    };
  }

  edit(item) {
    if (item.id) {
      this.$location.url("sharable-dashboard-builder/" + item.id + "/false");
    } else {
      //we should never hit this case but better safe than sorry
      this.$location.url("sharable-dashboard-builder/" + item.dashboardId);
    }
  }

  print(item) {
    this.$window.open(
      this.NEW_SHARABLE_DASHBOARD_URL.replace("http://", "https://") +
        "/sharable_dashboard_viewer/" +
        item.companyId +
        "/" +
        item.id +
        "/1",
      "_blank"
    );
  }

  confirmBulkDelete(ev) {
    var title = this.$translate.instant(
        "Are you sure you want to delete the selected reports?"
      ),
      content = this.$translate.instant("This action cannot be undone"),
      okLabelAction = this.$translate.instant("Delete"),
      cancelLabelAction = this.$translate.instant("Cancel");

    this.$mdDialog
      .show(
        this.$mdDialog
          .mwConfirm()
          .title(title)
          .textContent(content)
          .ok(okLabelAction)
          .cancel(cancelLabelAction)
          .targetEvent(ev)
      )
      .then(
        function okHandler() {
          this.deleteSelected();
        }.bind(this),
        function cancelHandler() {}
      );
  }

  deleteSelected() {
    if (this.selectedItems.length > 0) {
      var successMsg = "",
        idsToDelete = this.selectedItems.map(function (item) {
          return item.id;
        }),
        config = {
          method: "POST",
          url: "/sharable_dashboard_bulk_delete/" + this.companyId,
          data: { reportIds: idsToDelete },
        };

      this.loadPagePromise = this.$http(config)
        .then(
          function (response) {
            if (response.data.status === "OK") {
              if (response.data.failures.length > 0) {
                successMsg = this.$translate.instant(
                  "We were unable to delete some of your reports"
                );

                response.data.failures.forEach(
                  function (failure) {
                    idsToDelete.splice(idsToDelete.indexOf(failure), 1);
                  }.bind(this)
                );
              } else {
                successMsg = this.$translate.instant(
                  "Reports successfully deleted"
                );
              }

              this.items = this.items.filter(function (report) {
                return idsToDelete.indexOf(report.id) < 0;
              });
              this.resetSelectedItems();
              this.showToast(successMsg);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            var title = this.$translate.instant("Error"),
              content = this.$translate.instant(
                "There were errors deleting your reports"
              ),
              okLabelAction = this.$translate.instant("OK");

            this.showAlert(title, content, okLabelAction);
          }.bind(this)
        );
    }
  }

  view(item) {
    if (item.id && item.companyId) {
      this.$window.open(
        this.NEW_SHARABLE_DASHBOARD_URL.replace("http://", "https://") +
          "/sharable_dashboard/" +
          item.companyId +
          "/" +
          item.id
      );
    }
  }

  confirmDelete(item, ev) {
    var title = this.$translate.instant(
        "Are you sure you want to delete this report?"
      ),
      content = this.$translate.instant("This action cannot be undone"),
      okLabelAction = this.$translate.instant("Delete"),
      cancelLabelAction = this.$translate.instant("Cancel");

    this.$mdDialog
      .show(
        this.$mdDialog
          .mwConfirm()
          .title(title)
          .textContent(content)
          .ok(okLabelAction)
          .cancel(cancelLabelAction)
          .targetEvent(ev)
      )
      .then(
        function okHandler() {
          this.delete(item);
        }.bind(this),
        function cancelHandler() {}
      );
  }

  delete(item) {
    if (item.id) {
      this.loadPagePromise = this.$http
        .delete("/sharable_dashboard/" + this.companyId + "/" + item.id)
        .then(
          function (response) {
            if (response.data.status === "OK") {
              this.items = this.items.filter(function (report) {
                return report.id !== item.id;
              });

              this.selectedItems = this.selectedItems.filter(function (
                selected
              ) {
                return selected.id !== item.id;
              });

              this.paging.totalItems--;
              this.showToast(
                this.$translate.instant("Report successfully deleted")
              );
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            var title = item.dislayName,
              content = this.$translate.instant(
                "There was an error deleting your report"
              ),
              okLabelAction = this.$translate.instant("Delete");

            this.showAlert(title, content, okLabelAction);
          }.bind(this)
        );
    }
  }

  $onInit() {
    this.paging.totalItems = this.items.length;
    const isProd = window.location.hostname.indexOf(".com") !== -1;
    if (this.stateService.entitlements.length > 0) {
      this.checkShareEntitlements()
    } else {
      //TODO: Refactor this manifest loading code into its own service
      //Manually load entitlements if they are not available when this controller is loaded
      const manifestClient: any = window[EXTERNAL_NAME];
      if (!manifestClient) {
        throw new Error(
          "Could not find Manifest Client"
        );
      }
      let currentManifestEnvironment;
      if (isProd) {
        currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
      } else {
        currentManifestEnvironment = manifestClient.Environments.STAGING;
      }

      manifestClient.Initializer.initialize(currentManifestEnvironment);
      manifestClient.ManifestClient.getInstance()
        .then(maniInstance => maniInstance.getCurrentManifest())
        .then(mani => {
          this.stateService.entitlements = mani.entitlements.v6;
          this.checkShareEntitlements()
        })
    }
  }

  checkShareEntitlements() {
    var limit = this.SHARABLE_DASHBOARDS_LIMIT;
    if (
      this.stateService.entitlements["sharable-dashboards-premium"] !==
      undefined &&
      this.stateService.entitlements["sharable-dashboards-premium"] !== null &&
      this.stateService.entitlements["sharable-dashboards-premium"].value ===
      true
    ) {
      limit = this.SHARABLE_DASHBOARDS_PREMIUM_LIMIT;
    }
    if (this.items.length >= limit && this.shareLimitReached) {
      var title = this.$translate.instant("Shared Dashboards"),
        content = this.$translate.instant(
          "You have reached the maximum number of dashboards you're allowed to share. Consider deleting old links before trying again."
        ),
        okLabelAction = this.$translate.instant("OK");

      this.showAlert(title, content, okLabelAction);
    }
  }

  showToast(message) {
    if (message) {
      this.$mdToast.show(this.$mdToast.mwSimpleTimed().textContent(message));
    }
  }

  showAlert(title, textContent, okLabel) {
    this.$mdDialog
      .show(
        this.$mdDialog
          .mwAlert()
          .title(title)
          .htmlContent(
            this.$sce.trustAsHtml(
              '<p class="sharable-dasboards__alert-message">' +
                textContent +
                "</p>"
            )
          )
          .ok(okLabel)
      )
      .then(function okHandler() {});
  }

  $doCheck(obj) {}

  $onDestroy() {}

  onPage(page, limit) {
    this.paging.selectedPage = page;
    this.paging.itemsPerPage = limit;
  }

  resetSelectedItems() {
    this.selectedItems = [];
  }

  onReorder() {}

  isHeaderTitleVisible() {
    return !(this.$mdMedia("xs") && this.isSearchActive);
  }

  onSearchToggle(isSearchActive) {
    this.isSearchActive = isSearchActive;
  }

  search(searchText) {
    this.searchText = searchText;
  }

  setSortOrder(sortOrder) {
    if (this.sortOrder !== sortOrder) {
      this.sortOrder = sortOrder === "ASC" ? sortOrder : "DESC";
    }
  }

  showPassword(item, ev) {
    this.$mdDialog
      .show({
        autoWrap: false,
        fullscreen: true,
        bindToController: true,
        targetEvent: ev,
        onShowing: function () {
          this.$timeout(function () {
            angular.element("#link").select();
          }, 500);
        }.bind(this),
        locals: {
          $timeout: this.$timeout,
          $mdDialog: this.$mdDialog,
          $http: this.$http,
          config: item,
          origPassword: item.password,
          link:
            this.NEW_SHARABLE_DASHBOARD_URL +
            "/sharable_dashboard/" +
            item.companyId +
            "/" +
            item.id,
          showCopiedTooltip: function () {
            this.showCopySuccess = true;
            this.$timeout(
              function () {
                this.showCopySuccess = false;
              }.bind(this),
              3000
            );
          },
          saveConfig: function () {
            if (
              this.config !== undefined &&
              this.config !== null &&
              this.config.password !== undefined &&
              this.config.password !== null &&
              this.config.password !== "null" &&
              this.config.password !== ""
            ) {
              this.requestInProgress = true;
              this.$http
                .put("/aws/dynamoDb/sharableDashboard", this.config)
                .then(
                  function () {
                    this.$http.put("/aws/s3/update_password", this.config).then(
                      function () {
                        this.origPassword = this.config.password;
                        this.isDirty = false;
                        this.requestInProgress = false;
                      }.bind(this)
                    );
                  }.bind(this)
                );
            }
          },
        },
        //This is a globally available controller for the purposes of attaching locals for data binding
        controller: "MwMiniModalDialogController",
        controllerAs: "$ctrl",
        template: `
                <md-dialog id="share-dialog" class="mw-mini-modal" aria-label="" layout="column">
                    <mw-mini-modal-dialog class="mw-mini-modal-dialog" layout="column" data-title="{{'Password and link' | translate}}" ok="{{'OK' | translate}}" on-ok="$ctrl.$mdDialog.hide();" cancel="{{'Cancel' | translate}}" on-cancel="$ctrl.$mdDialog.hide();">
                        <mw-modal-content layout="column" ng-form="shareDashboardForm">
                            <mw-loader class="full-screen-loader" ng-show="$ctrl.requestInProgress"></mw-loader>
                            <div flex="100" layout="column">
                                <md-input-container flex="100">
                                    <label translate>Password</label>
                                    <input ng-model="$ctrl.config.password" name="password" required="true" ng-change="$ctrl.isDirty = ($ctrl.origPassword !== $ctrl.config.password);" />
                                    <div ng-messages="shareDashboardForm.password.$error">
                                        <div ng-message="required" translate="app__form-messaging--required-field"></div>
                                    </div>
                                    <div class="md-caption" translate>You can change your password any time.</div>
                                </md-input-container>
                                <div ng-if="$ctrl.isDirty === true" flex="100" layout="column" layout-align="start end">
                                    <md-button id="share-dialog__save-password__button" class="mw-button mw-button--outlined" ng-click="$ctrl.saveConfig();" ng-disabled="$ctrl.config.password === undefined || $ctrl.config.password === null || $ctrl.config.password.length === 0"><span translate>Update<span></md-button>
                                </div>
                            </div>
                            <div class="share-dashboard-dialog__link-container" flex="100" layout="column">
                                <md-input-container id="sharable-dashboard__link-input" flex="100">
                                    <label translate>Your dashboard link</label>
                                    <input id="link" name="link" ng-model="$ctrl.link" readonly />
                                </md-input-container>
                                <div flex="100" layout="row">
                                    <div flex="60" layout="column" layout-align="center start">
                                        <a id="sharable-dashboard__open-link" target="_blank" href="{{$ctrl.link}}" translate>Open in new window</a>
                                    </div>
                                    <div flex="40" layout="column" layout-align="start end">
                                        <md-button class="mw-button mw-button--outlined" ngclipboard data-clipboard-text="{{$ctrl.link}}" ngclipboard-success="$ctrl.showCopiedTooltip();"><span translate>Copy link</span></md-button>                                    
                                        <div class="share-dashoard-dialog__success-text" flex="100" ng-style="{'visibility': $ctrl.showCopySuccess === true ? 'visible' : 'hidden'}" translate>Copied!</div>
                                    </div>
                                </div>
                            </div>
                        </mw-modal-content>
                    </mw-mini-modal-dialog>
                </md-dialog>
            `,
      })
      .then(
        function () {},
        function () {}
      );
  }
}

sharableDashboardManagerConfig.controller = SharableDashboardManagerComponent;

export {
  sharableDashboardManagerConfig,
  SharableDashboardManagerComponent as default,
};
